// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"344":"9a193719","453":"8ab44547"}[chunkId] + ".chunk.js";
};